import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { AbstractControl, FormArray, FormBuilder, FormGroup } from "@angular/forms";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { EnrolmentOnboardModel, OnboardingEnrollmentsItem, OnboardingModeSelection } from "src/app/models/enrollment-onboard";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";
import { FormValidationService } from "src/app/services/form-validation.service";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-benefit-enrollment-onboarding-wizard-mode',
    templateUrl: './mode.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EnrollmentOnboardModeComponent implements OnInit {
    @Input() public enrolmentOnboardModel: EnrolmentOnboardModel;
    @Output() public emitComplete: EventEmitter<OnboardingEnrollmentsItem> = new EventEmitter();
    @Output() public emitContinueSession: EventEmitter<null> = new EventEmitter();

    public haveEnrollmentOptions: boolean;
    public modeForm: FormGroup;
    public modeFormArrayName: string = 'modeFormArrayName';
    public isSelect: string = 'isSelect';
    public apiUrl = ContentHeaderKey.EnrollmentAvailableEnrollments;
    public enrollmentInProgress: boolean;
    public welcomeMessage: string;

    constructor(
        private helperService: HelperService,
        private formBuilder: FormBuilder,
        private enrollmentManagerService: EnrollmentManagerService,
    ) {
    }

    ngOnInit() {
        this.haveEnrollmentOptions = this.enrolmentOnboardModel?.enrollments?.items.length > 0;

        let l_FormArray: FormArray = new FormArray([], FormValidationService.formArrayRequiresCheckboxChecked(this.isSelect));
        
        if (this.enrollmentManagerService.manager && this.enrollmentManagerService.manager.enrollmentMode) {
            this.enrollmentInProgress = true;
            this.welcomeMessage = this.enrollmentManagerService.manager.enrollmentMode.welcomeMessage;
            l_FormArray.push(
                this.formBuilder.group({
                    [this.isSelect]: [true],
                    mode: [this.enrollmentManagerService.manager.enrollmentMode.mode],
                    name: [this.enrollmentManagerService.manager.enrollmentMode.name],
                    message: [this.enrollmentManagerService.manager.enrollmentMode.messageForDisplay],
                    disabled: [this.enrollmentManagerService.manager.enrollmentMode.disabled],
                    beginDate: [this.helperService.toShortDate(this.enrollmentManagerService.manager.enrollmentMode.beginDate)],
                    expireDate: [this.helperService.toShortDate(this.enrollmentManagerService.manager.enrollmentMode.enrollExpireDate)],
                })
            );
        } else {
            if (this.haveEnrollmentOptions) {
                this.welcomeMessage = this.enrolmentOnboardModel?.welcomeHtml;
                this.enrolmentOnboardModel.enrollments.items.forEach((item: OnboardingEnrollmentsItem) => {
                    l_FormArray.push(
                        this.formBuilder.group({
                            [this.isSelect]: [true],
                            mode: [item.mode],
                            name: [item.name],
                            message: [item.messageForDisplay],
                            disabled: [item.disabled],
                            beginDate: [this.helperService.toShortDate(item.beginDate)],
                            expireDate: [this.helperService.toShortDate(item.enrollExpireDate)],
                        })
                    );
                });
            }
        }

        this.modeForm = this.formBuilder.group({
            [this.modeFormArrayName]: l_FormArray,
        });

        if (this.enrollmentInProgress)
            this.haveEnrollmentOptions = true;
    }

    get gridModeArray(): AbstractControl<any, any>[] {
        return (<FormArray>(this.modeForm.get(this.modeFormArrayName))).controls;
    }

    public continueWizard(): void {
        let l_OnboardingEnrollmentsItem = new OnboardingEnrollmentsItem();

        this.gridModeArray.forEach(gma => {
            if (gma.get(this.isSelect).value)
                l_OnboardingEnrollmentsItem = this.enrolmentOnboardModel.enrollments.items.find(i => i.mode == gma.get('mode').value);
        });

        this.emitComplete.emit(l_OnboardingEnrollmentsItem);
    }

    public continueSession(): void {
        this.emitContinueSession.emit();
    }
}